// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".online-button[data-v-1c44332d]{display:flex;align-items:center;justify-content:center;border:none;color:#fff;font-weight:500;border-radius:4px;background-color:#40b8b8;padding:8px 16px;text-decoration:none;text-align:center;cursor:pointer;max-width:120px}.icon[data-v-1c44332d]{margin-left:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
